import { useEffect, useState } from 'react'
import { FiBox, FiShoppingCart } from 'react-icons/fi'
import Reveal from './ui/Reveal'
import SectionTitle from './ui/SectionTitle'
import Card from './ui/Card'
import Button from './ui/Button'
import DevicePurchaseModal from './DevicePurchaseModal'
import AuthModal from './AuthModal'
import { useAuth } from '../contexts/AuthContext'
import { getAuth } from 'firebase/auth'
import { apiUrl } from '../config/api'

import dispositivo3ProductImg from '../assets/images/dispositivo3.png'

const FALLBACK_PRODUCTS = [
  {
    id: 'device01',
    name: 'Sys[mv] - R01',
    price: 'R$ 499,90',
    description: 'A compra do dispositivo libera a instalação e a assinatura do plano.',
    image: dispositivo3ProductImg,
    badge: 'Produto',
  },
]

const Products = () => {
  const [showDeviceModal, setShowDeviceModal] = useState(false)
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [shouldOpenDeviceAfterAuth, setShouldOpenDeviceAfterAuth] = useState(false)
  const [products, setProducts] = useState(FALLBACK_PRODUCTS)
  const { user } = useAuth()

  useEffect(() => {
    let alive = true
    fetch(apiUrl('/api/products'))
      .then((r) => r.json())
      .then((data) => {
        if (!alive) return
        const list = Object.entries(data?.produtos || {}).map(([key, p]) => ({
          id: p.productId || key,
          name: p.name || (key === 'device01' ? 'Sys[mv] - R01' : 'Produto'),
          description: p.description || '',
          badge: p.type ? String(p.type) : 'Produto',
          price:
            typeof p.amount === 'number'
              ? `R$ ${p.amount.toFixed(2).replace('.', ',')}`
              : 'R$ 499,90',
          image: dispositivo3ProductImg,
        }))
        if (list.length) setProducts(list)
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [])

  useEffect(() => {
    if (!showAuthModal) return
    if (!user) return
    if (!shouldOpenDeviceAfterAuth) return
    setShowAuthModal(false)
    setShouldOpenDeviceAfterAuth(false)
    setShowDeviceModal(true)
  }, [user, showAuthModal, shouldOpenDeviceAfterAuth])

  const requestBuyDevice = () => {
    if (!user) {
      setShouldOpenDeviceAfterAuth(true)
      setShowAuthModal(true)
      return
    }
    setShowDeviceModal(true)
  }

  return (
    <section id="products" className="section-padding bg-white dark:bg-gray-900/50 relative overflow-hidden">
      <div className="container-custom">
        <Reveal direction="up">
          <SectionTitle
            title="Produtos"
            subtitle="Comece pelo dispositivo"
            align="center"
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:gap-5 mt-8 sm:mt-10 max-w-xl mx-auto">
          {products.map((p, idx) => (
            <Reveal key={p.id} direction="up" delay={idx * 120}>
              <Card
                padding="md"
                hover
                glow={false}
                className="relative overflow-hidden flex flex-col"
              >
                <div className="mb-4 rounded-2xl overflow-hidden bg-accent/10 dark:bg-accent/20 border border-accent/20">
                  <img
                    src={p.image || dispositivo3ProductImg}
                    alt={p.name || 'Produto'}
                    className="w-full h-32 sm:h-40 object-contain"
                    loading="lazy"
                  />
                </div>

                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-accent/10 dark:bg-accent/20 text-accent flex items-center justify-center">
                    <FiBox className="w-6 h-6" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white truncate">
                      {p.name}
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{p.description}</p>
                  </div>
                </div>

                <div className="mt-auto mb-4">
                  <p className="text-sm font-semibold text-gray-500 dark:text-gray-400">Preço</p>
                  <p className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mt-1">{p.price}</p>
                </div>

                <Button
                  onClick={requestBuyDevice}
                  variant="primary"
                  size="sm"
                  className="w-full"
                >
                  <FiShoppingCart className="w-4 h-4 mr-2" />
                  Comprar dispositivo
                </Button>
              </Card>
            </Reveal>
          ))}
        </div>
      </div>

      {showDeviceModal && (
        <DevicePurchaseModal onClose={() => setShowDeviceModal(false)} />
      )}

      {showAuthModal && !user && (
        <AuthModal
          onClose={() => {
            setShowAuthModal(false)
            // Se o usuário fechou sem logar, não queremos manter a compra pendente.
            // Se o login foi bem-sucedido, o AuthContext vai atualizar `user` e o effect
            // vai abrir o modal do dispositivo automaticamente.
            setTimeout(() => {
              const currentUser = getAuth().currentUser
              if (!currentUser) setShouldOpenDeviceAfterAuth(false)
            }, 0)
          }}
        />
      )}
    </section>
  )
}

export default Products

